<template>
  <div class="complain-wrapper">
    <div class="submit-view" v-if="!showSuccess" ref="complainWrapper">
      <div class="desc">{{ description }}</div>
      <div class="realName shadow" v-if="isWSF">
        <div class="left">举报方式</div>
        <div class="right flex-row">
          <div @click="openRealName" class="div">{{ realNameSelectVal }}</div>
          <van-icon name="arrow-down" />
        </div>
      </div>
      <van-form @submit="onSubmit" ref="complainForm" class="accusationFormBox">
        <div class="title-text" v-if="isRealName || !isWSF">举报人信息</div>
        <div class="form-block" v-if="isRealName || !isWSF">
          <van-field
            class="form-input"
            v-model="accusationForm.complainantName"
            name="complainantName"
            label="姓名"
            placeholder="请输入姓名"
            maxlength="15"
          />
          <van-field
            class="form-input customInput"
            v-model="accusationForm.complainantRole"
            name="complainantRole"
            placeholder="请选择身份"
            :is-link="true"
            label="身份"
            readonly
            @click="showPopup('role')"
          />
          <van-field
            class="form-input"
            v-model="accusationForm.complainantMobile"
            name="complainantName"
            label="电话"
            readonly
            @pointerup="handleShowNum"
            :style="{
              pointerEvents: showNum ? 'none' : 'all',
            }"
            placeholder="请输入电话"
            maxlength="11"
          />
        </div>
        <div class="title-text">被举报人信息</div>
        <div class="form-block">
          <van-field
            class="form-input"
            v-model="accusationForm.respondentCompany"
            name="respondentCompany"
            label="单位"
            placeholder="请输入单位"
            maxlength="15"
          />
          <van-field
            class="form-input"
            v-model="accusationForm.respondentName"
            name="respondentName"
            label="姓名"
            placeholder="请输入姓名"
            maxlength="15"
          />
        </div>
        <div class="title-text">
          <span style="color:#FF6F00">*</span>举报事项
        </div>
        <div class="form-block">
          <van-field
            v-model="accusationForm.reportContent"
            type="textarea"
            maxlength="500"
            show-word-limit
            autosize
            name="reportContent"
            placeholder="请输入举报事项，不少于10个字"
            :rules="[
              {
                validator: reportContentValidator,
                message: '请输入举报事项，不少于10个字',
              },
            ]"
          />
        </div>
        <div class="upload-title title-text">
          <span>附件</span>
          <div @click="showPopup('upload')">
            <img src="../../assets/img/complain/icon_file_upload.png" alt="" />
            上传附件
          </div>
        </div>
        <div class="form-block">
          <div class="file-list">
            <van-uploader
              class="image-list"
              preview-size="70px"
              :show-upload="false"
              v-model="previewImages"
              @delete="deleteImage"
            />
            <div
              class="file-list-item"
              v-for="file in fileList"
              :key="file.key"
            >
              <div class="file-info">
                <img :src="getFileIcon(file.name)" alt="" />
                <span>{{ getNameFormat(file.name) }}</span>
              </div>
              <div class="close-icon" @click="removeFile(file.key)">x</div>
            </div>
          </div>
        </div>
      </van-form>
      <div
        :class="[
          submitLoading
            ? 'disable-btn'
            : !accusationForm.reportContent.length
            ? 'disable-btn'
            : 'submit-btn',
        ]"
        @click="handleSubmit"
      >
        {{ submitLoading ? '正在提交......' : '提交' }}
      </div>
    </div>
    <van-overlay :show="uploadLoading">
      <van-loading class="uplaod-loading-icon" type="spinner" />
    </van-overlay>
    <van-number-keyboard
      v-model="accusationForm.complainantMobile"
      :show="showNum"
      @blur="showNum = false"
    />
    <van-popup v-model="realNameShow" position="bottom" @closed="handleClose">
      <div class="realNameSelectBox">
        <van-picker
          show-toolbar
          title="请选择举报方式"
          ref="identityPicker"
          :columns="realNameColumns"
          @confirm="realNameConfirmHandler"
          @cancel="realNameShow = false"
          :style="{ background: currentType == 'upload' ? 'transparent' : '' }"
        />
      </div>
    </van-popup>
    <van-popup
      v-model="show"
      position="bottom"
      @closed="handleClose"
      :style="{ background: currentType == 'upload' ? 'transparent' : '' }"
    >
      <van-picker
        v-show="currentType == 'role'"
        title="请选择身份"
        show-toolbar
        @confirm="onConfirm"
        @cancel="show = false"
        :columns="columns"
      />
      <div class="upload-type" v-if="currentType == 'upload'">
        <div class="type-list">
          <input
            id="camera"
            type="file"
            @change="selectFile"
            accept="image/*"
            capture="camera"
          />
          <input
            id="camcorder"
            type="file"
            @change="selectFile"
            accept="video/*"
            capture="camcorder"
          />
          <!-- <input id="microphone" type="file" @change="selectFile" accept="audio/*" capture="microphone" /> -->
          <input
            id="photo"
            type="file"
            @change="selectFile"
            accept="image/*"
            multiple
          />
          <input id="file" type="file" @change="selectFile" multiple />
          <!-- <div class="upload-type-title">上传附件</div> -->
          <label class="upload-type-label" for="camera">拍照</label>
          <label class="upload-type-label" for="camcorder" v-if="!isWSF"
            >拍摄</label
          >
          <!-- <label class="upload-type-label" for="microphone">录音</label> -->
          <label class="upload-type-label" for="photo">从相册选取</label>
          <label class="upload-type-label" for="file" v-if="!isWSF"
            >选择文件</label
          >
        </div>
        <div class="cancel-btn" @click="show = false">取消</div>
      </div>
    </van-popup>
    <div class="success-view" v-if="showSuccess">
      <div class="success-bg"></div>
      <div class="success-text">{{ isWSF ? '举报' : '投诉' }}成功</div>
      <div class="continue-btn" @click="showSuccess = false">
        继续发起{{ isWSF ? '举报' : '投诉' }}
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, Uploader, Toast } from 'vant';
import {
  uploadFile,
  addComplaintCollection,
  getTemplateDetail,
  getTemplateDetailForApp,
} from '../../api/accusation';
import 'vant/lib/form/style';
import 'vant/lib/field/style';
import 'vant/lib/popup/style';
import 'vant/lib/picker/style';
import 'vant/lib/uploader/style';
import 'vant/lib/number-keyboard/style';
import 'vant/lib/overlay/style';
export default {
  name: 'Accusation',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    vanPopup: () => import('vant/lib/popup'),
    vanPicker: () => import('vant/lib/picker'),
    vanOverlay: () => import('vant/lib/overlay'),
    vanNumberKeyboard: () => import('vant/lib/number-keyboard'),
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      accusationForm: {
        complainantName: '',
        complainantRole: '',
        complainantMobile: '',
        respondentCompany: '',
        respondentName: '',
        reportContent: '',
      },
      description: '',
      show: false,
      showSuccess: false,
      showNum: false,
      columns: ['供方', '合作伙伴', '商户', '其他'],
      currentType: '',
      allFiles: [],
      canPreviewTypes: ['gif', 'jpeg', 'png', 'jpg', 'svg'],
      audioTypes: [
        'wav',
        'flac',
        'ape',
        'alac',
        'mp3',
        'aac',
        'opus',
        'amr',
        'm4a',
      ],
      docTypes: ['doc', 'docx'],
      videoTypes: [
        'wmv',
        'asf',
        'asx',
        'rm',
        'rmvb',
        'mp4',
        '3gp',
        'mov',
        'm4v',
        'avi',
        'dat',
        'mkv',
        'flv',
        'vob',
      ],
      uploadLoading: false,
      submitLoading: false,
      fileSize: 100 * 1024 * 1024,
      isWSF: false,
      realNameShow: false,
      realNameColumns: ['实名', '匿名'],
      realNameSelectVal: '匿名',
      channelName: '',
      organization: '',
      organizationCode: '',
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  methods: {
    initData() {
      this.isWSF = !!localStorage.getItem('account');
      // this.isWSF = true;
      this.initialDesc();
    },
    async initialDesc() {
      let res = null;
      if (this.isWSF) {
        res = await getTemplateDetailForApp();
        this.realNameSelectVal = '实名';
        this.$nextTick(() => {
          this.accusationForm.complainantName = this.$store.state.account.name;
          this.accusationForm.complainantMobile = this.$store.state.account.mobile;
          this.accusationForm.complainantRole = '商户';
          this.channelName = res.channelName;
          this.organization = this.plazaName;
          this.organizationCode = this.plazaId;
        });
      } else {
        if (!this.$route.query.id) return;
        res = await getTemplateDetail(this.$route.query.id);
      }

      this.description = res.complaintDescription;
      this.organization = this.plazaName;
      this.organizationCode = this.plazaId;
    },
    openRealName() {
      this.realNameShow = true;
      this.$nextTick(() => {
        this.$refs.identityPicker.setValues([this.realNameSelectVal]);
      });
    },
    reportContentValidator(value) {
      if (!value.length) return false;
      if (value.length < 10) return false;
      else return true;
    },
    getFileIcon(filename) {
      let arr = filename.split('.');
      let postfix = arr[arr.length - 1];
      if (this.docTypes.includes(postfix)) {
        return require('../../assets/img/complain/icon_file_doc.png');
      } else if (this.videoTypes.includes(postfix)) {
        return require('../../assets/img/complain/icon_file_mp4.png');
      } else if (this.audioTypes.includes(postfix)) {
        return require('../../assets/img/complain/icon_file_amr.png');
      } else return require('../../assets/img/complain/icon_file_other.png');
    },
    showPopup(type) {
      this.currentType = type;
      this.show = true;
    },
    onConfirm(value) {
      this.accusationForm.complainantRole = value;
      this.show = false;
    },
    realNameConfirmHandler(val) {
      this.realNameSelectVal = val;
      this.realNameShow = false;
      if (val === '匿名') {
        this.accusationForm.complainantName = '';
        this.accusationForm.complainantMobile = '';
        this.accusationForm.complainantRole = '';
      }
    },
    handleClose() {
      this.currentType = '';
    },
    async onSubmit() {
      this.submitLoading = true;
      let submitParams = {
        channelName: this.$route.query.channelName || this.channelName,
        commonFiles: [],
        complaintTemplateId: this.$route.query.id,
        reportMatter: this.accusationForm.reportContent,
        reportedName: this.accusationForm.respondentName,
        reportedPersonUnit: this.accusationForm.respondentCompany,
        whistleblower: this.accusationForm.complainantName,
        whistleblowerIdentity: this.accusationForm.complainantRole,
        whistleblowerPhone: this.accusationForm.complainantMobile,
        organization: this.organization,
        organizationCode: this.organizationCode,
      };
      this.allFiles.forEach(file => {
        submitParams.commonFiles.push({
          fileName: file.name,
          filePath: file.url,
        });
      });
      let jsonParam = JSON.stringify(submitParams);
      await addComplaintCollection(jsonParam).finally(() => {
        this.submitLoading = false;
      });
      this.resetForm();
      this.showSuccess = true;
    },
    handleSubmit() {
      document.activeElement.blur();
      if (!this.accusationForm.reportContent.length) return;
      let inputStr =
        this.accusationForm.reportContent +
        this.accusationForm.respondentName +
        this.accusationForm.complainantName +
        this.accusationForm.respondentCompany;
      if (this.$bsUtils.bsHasEmojiCharacter(inputStr)) {
        Toast({
          message: '提交内容不能包含表情符号',
          duration: 3000,
          position: 'top',
        });
        return;
      }
      this.$refs.complainForm && this.$refs.complainForm.submit();

      this.$nextTick(() => {
        this.$refs.complainWrapper.scrollTop = 0;
      });
    },
    getNameFormat(name) {
      let filename = name.split('.')[0];
      let suffix = name.split('.')[1];
      if (filename.length <= 15) {
        return name;
      } else {
        let s = filename.slice(0, 9);
        let e = filename.slice(-3);
        return s + '...' + e + '.' + suffix;
      }
    },
    async selectFile(e) {
      if (!e.target.files) return;
      let formData = new FormData();
      formData.set('path', 'complaintCollection');
      let isNotChecked = this.checkFile(e.target.files, formData);
      this.show = false;
      if (isNotChecked) return;
      this.uploadLoading = true;
      let res = await uploadFile(formData).finally(() => {
        this.uploadLoading = false;
      });
      if (!res) return;
      if (res.imageVOs && res.imageVOs.length > 0) {
        res.imageVOs.forEach(item => {
          this.allFiles.push({
            url: item.url,
            name: item.oriName,
            key: item.key,
          });
        });
      }
    },
    checkFile(files, formData) {
      if (files.length + this.allFiles.length > 5) {
        Toast.fail('上传文件数量超过5个');
        return true;
      }
      // let hasSame = false
      let hasOverSize = false;
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > this.fileSize) {
          Toast.fail(`文件${files[i].name}超过100M`);
          hasOverSize = true;
          break;
        }
        // let idx = this.allFiles.findIndex((item)=> {
        //   return item.name == files[i].name
        // })
        // if(idx != -1) {
        //   Toast.fail(`存在同名文件${files[i].name}`)
        //   hasSame = true
        //   break
        // }
        formData.append('files', files[i]);
      }
      return hasOverSize;
    },
    removeFile(key) {
      let idx = this.allFiles.findIndex(file => {
        return file.key == key;
      });
      if (idx == -1) return;
      this.allFiles.splice(idx, 1);
    },
    handleShowNum() {
      this.showNum = !this.showNum;
    },
    deleteImage(image) {
      let idx = this.allFiles.findIndex(file => {
        return file.key == image.key;
      });
      if (idx == -1) return;
      this.allFiles.splice(idx, 1);
    },
    resetForm() {
      this.allFiles = [];
      this.accusationForm = {
        complainantName: '',
        complainantRole: '',
        complainantMobile: '',
        respondentCompany: '',
        respondentName: '',
        reportContent: '',
      };
      this.show = false;
      this.showNum = false;
    },
  },
  computed: {
    previewImages() {
      let imgArr = this.allFiles.filter(file => {
        let arr = file.name.split('.');
        let postfix = arr[arr.length - 1];
        return this.canPreviewTypes.includes(postfix);
      });
      return imgArr;
    },
    fileList() {
      let fileArr = this.allFiles.filter(file => {
        let arr = file.name.split('.');
        let postfix = arr[arr.length - 1];
        return !this.canPreviewTypes.includes(postfix);
      });
      return fileArr;
    },
    isRealName() {
      return this.realNameSelectVal === '实名';
    },
    plazaId(){
      return this.$store.state.account.plazaId
    },
    plazaName(){
      return this.$store.state.account.plazaName
    },
  },
  watch: {
    showSuccess(flag) {
      if (!flag) {
        this.initData();
        // window.location.reload();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.complain-wrapper {
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  background: #f8f8f8;
  font-size: 16px;
  line-height: initial;
  text-align: left;
  padding: 0 10px;
  .submit-view {
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
  }
  .desc {
    margin-top: 14px;
    padding: 20px 14px;
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    color: #666;
  }
  .title-text {
    height: 22px;
    line-height: 22px;
    font-size: 13px;
    color: #999;
    padding: 0 14px;
    margin: 16px 0 8px;
  }
  .form-block {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
    & /deep/ .van-cell {
      background: transparent;
    }
    .form-input /deep/ .van-field__control {
      text-align: right;
    }
  }
  .upload-title {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
      color: #416bed;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
  .image-list {
    padding: 14px 15px 0;
  }
  .file-list {
    font-size: 14px;
    color: #333;
    .file-list-item {
      padding: 15px 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .file-info {
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
      }
      // & /deep/ .van-uploader__preview:nth-child(4n) {
      //   margin-right: 0;
      // }
    }
    .close-icon {
      width: 17px;
      height: 17px;
      background: #ababab;
      border-radius: 50%;
      text-align: center;
      line-height: 17px;
      color: #fff;
    }
  }
  .upload-type {
    width: 100%;
    .type-list {
      display: flex;
      margin: 0 10px;
      flex-direction: column;
      border-radius: 8px;
      overflow: hidden;
      font-size: 14px;
      & > input {
        display: none;
      }
      .upload-type-title {
        text-align: center;
        padding: 0 24px;
        height: 44px;
        line-height: 44px;
        font-weight: bold;
        color: #333;
        background: #fff;
      }
      .upload-type-label {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 24px;
        height: 44px;
        background: #fff;
        color: #333;
        position: relative;
        &::after {
          position: absolute;
          left: 24px;
          right: 24px;
          bottom: 0;
          content: '';
          height: 1px;
          display: block;
          background: #e4e4e4;
        }
      }
    }
    .cancel-btn {
      border-radius: 8px;
      margin: 8px 10px 24px;
      padding: 0 24px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #fff;
      color: #FF6F00;
    }
  }
  .disable-btn {
    margin: 40px 0 24px;
    text-align: center;
    color: #ccc;
    height: 44px;
    line-height: 44px;
    border-radius: 22px;
    background: #e4e4e4;
  }
  .submit-btn {
    margin: 40px 0 24px;
    text-align: center;
    color: #fff;
    height: 44px;
    line-height: 44px;
    background: #FF6F00;
    border-radius: 22px;
  }
  .uplaod-loading-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .success-view {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #fff;
    padding: 119px 10px 0;
    z-index: 1000;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    .success-bg {
      width: 100px;
      height: 100px;
      background: url('../../assets/img/questionnaire/img_result_success@3x.png')
        no-repeat;
      background-size: 100% 100%;
      margin-bottom: 18px;
    }
    .success-text {
      font-size: 16px;
      color: #666666;
      margin-bottom: 55px;
    }
    .continue-btn {
      font-size: 16px;
      height: 44px;
      width: 100%;
      line-height: 44px;
      text-align: center;
      border-radius: 22px;
      color: #FF6F00;
      border: 1px solid #FF6F00;

    }
  }
}

.realName {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-top: 10px;
  background: #ffffff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
  .right {
    align-items: center;
    .div {
      margin-right: 2px;
    }
  }
}
</style>
